<hr class="upperline" />

<div class="my-account-form-container terra-error-style" [formGroup]="formGroup" [class.loading-container-overlay]="isLoading">
  <div class="form-grid">

    <p *ngIf="isDisabled">
      You can't change this because your using extrenal login provider
    </p>

    <!-- Current password -->
    <div class="terra-form-field-wrapper full-width">
      <label for="txtCurrentPassword" class="text-input-label">Current password</label>
      <mat-form-field appearance="outline" class="half-width">
        <input type="password" matInput id="txtCurrentPassword" formControlName="currentPassword" required maxlength="16" class="lo_sensitive" />
        <mat-error *ngIf="hasError('currentPassword', 'required')">Required</mat-error>
        <mat-error *ngIf="hasError('currentPassword', 'minlength') && !hasError('currentPassword', 'required')">
          Password should be at least 8 characters long
        </mat-error>
      </mat-form-field>
    </div>

    <!-- New password -->
    <div class="terra-form-field-wrapper full-width">
      <label for="txtNewPassword" class="text-input-label">New password</label>
      <mat-form-field appearance="outline" class="half-width">
        <input type="password" matInput id="txtNewPassword" formControlName="password" required maxlength="16" class="lo_sensitive" />
        <mat-error *ngIf="hasError('password', 'required'); else formatErrors">New password is required</mat-error>
        <ng-template #formatErrors>
          <mat-error *ngIf="hasError('password', 'minlength') && !hasError('password', 'passwordstrength')">
            Password should be at least 8 characters long
          </mat-error>
          <mat-error *ngIf="hasError('password', 'passwordstrength') && !hasError('password', 'minlength')">
            New password should contain at least one letter and one digit
          </mat-error>
          <!-- Both format errors -->
          <mat-error *ngIf="hasError('password', 'passwordstrength') && hasError('password', 'minlength')">
            Password should be at least 8 characters and contain at least one letter and one digit
          </mat-error>
          <mat-error *ngIf="hasError('password', 'samePassword')">New password should be different than your current password</mat-error>
        </ng-template>
      </mat-form-field>
    </div>

    <!-- Confirm password -->
    <div class="terra-form-field-wrapper full-width">
      <label for="txtConfirmPassword" class="text-input-label">Confirm password</label>
      <mat-form-field appearance="outline" class="half-width">
        <input
          type="password"
          [errorStateMatcher]="matcher"
          matInput
          id="txtConfirmPassword"
          formControlName="confirmPassword"
          required
          maxlength="16"
          class="lo_sensitive"
        />
        <!-- Show only 1 error -->
        <mat-error *ngIf="hasError('confirmPassword', 'required')">Required</mat-error>
        <mat-error *ngIf="formGroup.hasError('matchPassword') && !hasError('confirmPassword', 'required')">Passwords do not match</mat-error>
      </mat-form-field>
    </div>

    <div class="error-message full-width" *ngIf="hasError('currentPassword', 'badrequest')">The current password entered is incorrect</div>

    <terra-loader class="full-width" *ngIf="isLoading" centerToParent="true"></terra-loader>

    <button mat-flat-button color="accent" [disabled]="isDisabled" class="page-cta half-width tall-button" (click)="savePassword()">
      Save
    </button>
  </div>
</div>
